import { render, staticRenderFns } from "./ResponseCallout.vue?vue&type=template&id=640c2db7"
import script from "./ResponseCallout.vue?vue&type=script&lang=js"
export * from "./ResponseCallout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports